import { create } from "zustand";
import { AlertColor } from "@mui/material";

export interface Toast {
  id: string;
  message: string;
  type: AlertColor;
  duration?: number;
}

interface ToastState {
  toasts: Toast[];
  addToast: (message: string, type?: AlertColor, duration?: number) => void;
  removeToast: (id: string) => void;
  success: (message: string, duration?: number) => void;
  error: (message: string, duration?: number) => void;
  warning: (message: string, duration?: number) => void;
  info: (message: string, duration?: number) => void;
}

/**
 * Store Zustand pour gérer les toasts/notifications
 */
export const useToastStore = create<ToastState>((set) => ({
  toasts: [],

  addToast: (message, type = "info", duration = 6000) => {
    const id = Date.now().toString() + Math.random().toString(36).substr(2, 9);
    set((state) => ({
      toasts: [...state.toasts, { id, message, type, duration }],
    }));
    // Note: L'auto-suppression est gérée dans ToastWithAutoHide via useEffect
  },

  removeToast: (id) => {
    set((state) => ({
      toasts: state.toasts.filter((toast) => toast.id !== id),
    }));
  },

  success: (message, duration) => {
    useToastStore.getState().addToast(message, "success", duration);
  },

  error: (message, duration) => {
    useToastStore.getState().addToast(message, "error", duration);
  },

  warning: (message, duration) => {
    useToastStore.getState().addToast(message, "warning", duration);
  },

  info: (message, duration) => {
    useToastStore.getState().addToast(message, "info", duration);
  },
}));
